module.exports = __webpack_public_path__ + "static/media/txt.acafeac8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/txt.svg
// module id = 1691
// module chunks = 17